import { render, staticRenderFns } from "./SidemenuIcon.vue?vue&type=template&id=db2e5ac0&scoped=true&"
import script from "./SidemenuIcon.vue?vue&type=script&lang=js&"
export * from "./SidemenuIcon.vue?vue&type=script&lang=js&"
import style0 from "./SidemenuIcon.vue?vue&type=style&index=0&id=db2e5ac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2e5ac0",
  null
  
)

export default component.exports